import React from 'react';
import {Button, Card, CardContent, Grid } from '@mui/material';
import styles from 'styles/informacionDelCard';
import TituloConIcono from 'components/tituloConIcono';
import ElementoDelCard from 'components/card/ElementoDelCard';
import { Visibility } from '@mui/icons-material';
import { functions } from 'constantes/functions';

const DetalleDeLaEmpresa = ({datosGeneralesDeSolicitud, obtenerDocumentoAdjunto}) => {
  const classes = styles();

  const {
    telefono,
    telefono1,
    nombreEmpresa,
    direccion,
    correoElectronico,
    notificacion,
    patente,
    patenteRegistro,
    patenteFolio,
    patenteLibro,
    numeroRegistroTimbre,
    fechaVigenciaHastaTimbre,
    NumeroRegistro,
    FechaInscripcion,
    FechaVigencia,
    nombreEnlaceMedio,
    correoEnlaceMedio,
    telEnlaceMedio,
    solicitudPersonaJuridica,
    // Nuevos campos del registro de timbre de prensa
    codigoInscripcionTimbre,
    fechaInscripcionTimbre,
    fechaSolvenciaTimbre,
    archivoTimbre,
    solvenciaTimbre,
    pdfConstInscr,
    pdfSolvenciaTimbre,
    pdfConstanciaRegistroPrensa,
    pdfSolvenciaPagoTimbre
  } = datosGeneralesDeSolicitud;

  const codigoInscripcion = codigoInscripcionTimbre || numeroRegistroTimbre || NumeroRegistro || "";
  const fechaInscripcion = fechaInscripcionTimbre || FechaInscripcion || "";
  const fechaSolvencia = fechaSolvenciaTimbre || fechaVigenciaHastaTimbre || FechaVigencia || "";

  const nombreArchivoConstancia = pdfConstanciaRegistroPrensa
    ? "pdfConstanciaRegistroPrensa"
    : (pdfConstInscr ? "pdfConstInscr" : "archivoTimbre");
  const nombreArchivoSolvencia = pdfSolvenciaPagoTimbre
    ? "pdfSolvenciaPagoTimbre"
    : (pdfSolvenciaTimbre ? "pdfSolvenciaTimbre" : "solvenciaTimbre");

  const puedeConsultarAdjuntos = !!datosGeneralesDeSolicitud?.id;

  const formatearFecha = (fecha) => {
    if (!fecha) return "";
    return String(fecha).includes("/") ? fecha : (functions.FormatearFecha(fecha) || "");
  };

  return (
    <Card className={classes.root}>
        <CardContent>
          <Grid container justify="center" alignItems="center">
            <Grid item xs={12}>
              <TituloConIcono title={"Datos de la empresa"} mostrarTiempo={false} mostrarBotones={false} showIcon={false} />
              <ElementoDelCard title={'Nombre de la empresa:'} label={nombreEmpresa || ""}/>
            </Grid>

            <Grid item xs={12}>
              <TituloConIcono title={"Datos de contacto de la empresa"} mostrarTiempo={false} mostrarBotones={false} showIcon={false} />
              <ElementoDelCard title={'Dirección de la empresa:'} label={direccion || ""} />
              <ElementoDelCard title={'Dirección para recibir notificaciones'} label={notificacion || ""} />
              <ElementoDelCard title={'Correo electrónico:'} label={correoElectronico || ""} />
              <ElementoDelCard title={'Teléfono:'} label={telefono || ""}/>
              <ElementoDelCard title={'Teléfono2:'} label={telefono1} />
            </Grid>

            <Grid item xs={12}>
              <TituloConIcono title={"Datos enlace de medio con TSE"} mostrarTiempo={false} mostrarBotones={false} showIcon={false} />
              <ElementoDelCard title={'Nombre:'} label={nombreEnlaceMedio || ""}/>
              <ElementoDelCard title={'Correo electrónico:'} label={correoEnlaceMedio || ""}/>
              <ElementoDelCard title={'Teléfono:'} label={telEnlaceMedio || ""}/>
            </Grid>

            <Grid item xs={12}>
              <TituloConIcono title={"Detalle de patente de comercio"} mostrarTiempo={false} mostrarBotones={false} showIcon={false} />
              <ElementoDelCard title={'Número de expediente:'} label={patente || ""}/>
              <ElementoDelCard title={'Número de registro:'} label={patenteRegistro || ""}/>
              <ElementoDelCard title={'Folio:'} label={patenteFolio || ""}/>
              <ElementoDelCard title={'Libro:'} label={patenteLibro || ""}/>
            </Grid>

            <Grid item xs={12}>
              <TituloConIcono title={"Tipo de propietario"} mostrarTiempo={false} mostrarBotones={false} showIcon={false} />
              <ElementoDelCard title={'Tipo de propietario:'} label={ solicitudPersonaJuridica?.length > 0 ? "PERSONA JURÍDICA" : "PERSONA INDIVIDUAL" || "" }/>
            </Grid>

            <Grid item xs={12}>
              <TituloConIcono title={"Registro de timbre de prensa"} mostrarTiempo={false} mostrarBotones={false} showIcon={false} />
              <ElementoDelCard title={'Código de inscripción:'} label={codigoInscripcion}/>
              <ElementoDelCard title={'Fecha de inscripción:'} label={formatearFecha(fechaInscripcion)}/>
              <ElementoDelCard title={'Fecha de solvencia:'} label={formatearFecha(fechaSolvencia)}/>
            </Grid>
            <Grid item xs={12} container spacing={2} mt={2}>
              <Grid item xs={12} md={6} mt={2}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => obtenerDocumentoAdjunto({id: 1, nombre: "empresa"}, nombreArchivoConstancia)}
                  size="large"
                  disabled={!puedeConsultarAdjuntos}
                >
                  <Visibility />
                  Ver constancia del registro de prensa
                </Button>
              </Grid>
              <Grid item xs={12} md={6} mt={2}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => obtenerDocumentoAdjunto({id: 1, nombre: "empresa"}, nombreArchivoSolvencia)}
                  size="large"
                  disabled={!puedeConsultarAdjuntos}
                >
                  <Visibility />
                  Ver solvencia de pago de timbre
                </Button>
              </Grid>
            </Grid>

            <Grid container justify="center" alignItems="center">
            <Grid item xs={12} md={6} mt={2}>
              <Button variant="contained" color="primary" onClick={() => obtenerDocumentoAdjunto({id: 1, nombre: "empresa"}, "patenteDeComercio")} size="large">
                <Visibility />
                Ver patente de comercio
              </Button>
            </Grid>
            <Grid item xs={12} md={6} mt={2}>
              <Button variant="contained" color="primary" onClick={() => obtenerDocumentoAdjunto({id: 1, nombre: "empresa"}, "declaracionJurada")} size="large">
                <Visibility />
                Ver declaración jurada
              </Button>
            </Grid>
          </Grid>

          </Grid>
        </CardContent>
    </Card>
  );
}

export default DetalleDeLaEmpresa;